export default "__VITE_ASSET__Bs0cuXMc__"